import BillSwitchFundingScreen from 'features/billSwitch/screens/BillSwitchFundingScreen/BillSwitchFundingScreen';
import React from 'react';

export default function BillSwitchFundingPage() {
  return <BillSwitchFundingScreen />;
}
